export const noop = (): void => {
  // noop
};
